import Header from "@/components/navigation/Header";
import Footer from "@/components/sections/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Shield, FileText, CreditCard, Wallet, Server, Users, BarChart3, CheckCircle, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
const Services = () => {
  const serviceCategories = [{
    title: "Investment Strategy Services",
    description: "Comprehensive Bitcoin investment planning for real estate professionals",
    services: [{
      name: "Hybrid Bitcoin/Real Estate Investment Strategies",
      description: "Develop innovative approaches combining traditional real estate with Bitcoin opportunities",
      icon: Building2,
      features: ["Portfolio diversification analysis", "Risk assessment and mitigation", "Strategic planning and implementation", "Performance monitoring and optimization"]
    }, {
      name: "Bitcoin Investment Policy Development",
      description: "Create tailored investment policies for institutional and individual investors",
      icon: FileText,
      features: ["Custom policy creation", "Regulatory compliance guidelines", "Risk management frameworks", "Investment committee governance"]
    }]
  }, {
    title: "Security & Custody Solutions",
    description: "Professional-grade Bitcoin storage and security services",
    services: [{
      name: "Wallets & Custody Solutions",
      description: "Institutional-grade Bitcoin storage with maximum security",
      icon: Wallet,
      features: ["Multi-signature wallet setup", "Hardware wallet configuration", "Cold storage solutions", "Key management protocols"]
    }, {
      name: "Cybersecurity & Protection",
      description: "Comprehensive security protocols for Bitcoin holdings",
      icon: Shield,
      features: ["Security audits and assessments", "Best practices implementation", "Incident response planning", "Ongoing security monitoring"]
    }]
  }, {
    title: "Financial Services",
    description: "Bitcoin financial products and reporting solutions",
    services: [{
      name: "Bitcoin Collateralized Lending",
      description: "Navigate Bitcoin-backed lending for real estate investments",
      icon: CreditCard,
      features: ["Loan structuring and terms", "Risk evaluation and management", "Platform selection and vetting", "Ongoing monitoring and support"]
    }, {
      name: "Financial Reporting & Accounting",
      description: "Accurate Bitcoin accounting for tax and financial management",
      icon: BarChart3,
      features: ["Tax reporting and compliance", "Accounting system integration", "Valuation methodologies", "Financial statement preparation"]
    }]
  }, {
    title: "Technical & Advisory Services",
    description: "Technical implementation and ongoing advisory support",
    services: [{
      name: "Bitcoin Node Operations",
      description: "Set up and maintain Bitcoin nodes for enhanced privacy",
      icon: Server,
      features: ["Node setup and configuration", "Ongoing maintenance and updates", "Network optimization", "Privacy enhancement protocols"]
    }, {
      name: "Investor Communications & Education",
      description: "Clear communication strategies for Bitcoin investments",
      icon: Users,
      features: ["Stakeholder education programs", "Custom reporting templates", "Presentation materials", "Regular market updates"]
    }]
  }];
  return <div className="min-h-screen bg-background">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white py-[100px]">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Professional Bitcoin Advisory Services
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Comprehensive Bitcoin solutions designed specifically for real estate investors 
              and professionals seeking to integrate Bitcoin into their investment strategies.
            </p>
          </div>
        </div>
      </section>

      {/* Services Sections */}
      <main className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {serviceCategories.map((category, categoryIndex) => <section key={categoryIndex} className="mb-20">
              <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-foreground mb-4">
                  {category.title}
                </h2>
                <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                  {category.description}
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {category.services.map((service, serviceIndex) => {
              const IconComponent = service.icon;
              return <Card key={serviceIndex} className="h-full hover:shadow-soft transition-smooth">
                      <CardHeader>
                        <div className="flex items-center space-x-3 mb-4">
                          <div className="p-3 bg-bitcoin-orange/10 rounded-lg">
                            <IconComponent className="h-8 w-8 text-bitcoin-orange" />
                          </div>
                        </div>
                        <CardTitle className="text-2xl font-bold text-foreground">
                          {service.name}
                        </CardTitle>
                        <CardDescription className="text-muted-foreground text-base">
                          {service.description}
                        </CardDescription>
                      </CardHeader>
                      <CardContent>
                        <ul className="space-y-3">
                          {service.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-start">
                              <CheckCircle className="h-5 w-5 text-bitcoin-orange mr-3 mt-0.5 flex-shrink-0" />
                              <span className="text-muted-foreground">{feature}</span>
                            </li>)}
                        </ul>
                      </CardContent>
                    </Card>;
            })}
              </div>
            </section>)}
        </div>
      </main>

      {/* CTA Section */}
      <section className="py-16 bg-muted">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Ready to Integrate Bitcoin into Your Real Estate Strategy?
          </h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Schedule a consultation with our Bitcoin experts to discuss your specific needs 
            and develop a customized strategy for your real estate investment portfolio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="hero" size="lg" className="text-lg px-8 py-6" asChild>
              <Link to="/contact">
                Schedule Consultation <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            <Button variant="outline" size="lg" className="text-lg px-8 py-6" asChild>
              <Link to="/blog">
                Learn More
              </Link>
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>;
};
export default Services;